import { constant } from '@medflex/commons';

export default contact => {
  if (contact.user.workArea) return null;
  if (!contact.user.areaOfActivity) return null;
  if (constant.areaOfActivity[contact.user.areaOfActivity] !== constant.areaOfActivity.CUSTOM)
    return constant.areaOfActivity[contact.user.areaOfActivity];
  return null;
};
